import gql from "graphql-tag";
import { taskInternalPartnerFileTypeDef } from "../definitions/task-internal-partner-file-type-def";

const removeInternalPartnerTaskFileMutation = gql`
  mutation removeInternalPartnerTaskFile (
  $taskFileId: String!
  ) {
    taskInternalPartnerFile{
      remove(input: {
        id: $taskFileId
      }) {
        output {
          ${taskInternalPartnerFileTypeDef}
        }
      }
    }
  }`;

export default removeInternalPartnerTaskFileMutation;
